import axios from 'axios';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { RenderDatePicker, RenderTextArea } from '../../../component/formInput';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import moment from 'moment';
 
const validate = (values) => {
  const errors = [];
  if(!values.suspend_reason) {
    errors.suspend_reason = "Vui lòng nhập lý do Suspend !"
  }
  return errors;
}

class SuspendManualModal extends React.Component {

  constructor(props) {
    super(props);
  }

  handleOnHide = () => {
    const { onHide, destroy } = this.props;
    destroy();
    onHide();
  }

  submit = (values) => {
    const { userProduct } = this.props;
    const self = this;
    return axios({
      method: 'post',
      url: window.api_url + '/admin/api/suspend/service/manual',
      data: {
        user_product_id: userProduct.id,
        suspend_reason: values.suspend_reason
      },
      withCredentials: true
    }).then(function (response) {
      if (!response.data.isError) {
        toast.success("Suspend Thành Công !")
        self.handleOnHide();
      } else {
        toast.error(response.data.error)
      }
    })
  }

  render() {
    const { title, submitting, userProduct, handleSubmit } = this.props;
    const modalConfig = { backdrop: 'static', show: this.props.show, bssize: "medium", onHide: this.props.onHide, submitting: this.props.submitting };
    return <div style={{ width: '30%' }}>
      <ToastContainer />
      <Modal {...modalConfig} aria-labelledby="contained-modal-title-lg">
        <Modal.Header className="bg-danger" closeButton>
          <Modal.Title id="contained-modal-title-sm">{title}</Modal.Title>
        </Modal.Header>
          <form onSubmit={handleSubmit(this.submit)}>
            <Modal.Body>
              <div style={{paddingTop:20}}> 
                <p><strong> Tên Dịch Vụ:  </strong> {userProduct.product && userProduct.product.name}</p>
                <p><strong> Domain / Code:  </strong> {userProduct  && userProduct.domain}</p>
                <p><strong> IP Address:  </strong> {userProduct  && userProduct.ip_address}</p>
                <Field name="suspend_reason" placeholder="Vui lòng nhập lý do suspend dịch vụ" label="Lý Do" component={RenderTextArea} />
              </div>  
            </Modal.Body>
            <Modal.Footer>
              <div className="text-right">
                <a style={{marginRight: 10}} className="btn" onClick={() => this.handleOnHide()}>Đóng</a>
                <button type="submit" className="btn bg-danger" disabled={submitting}>Suspend</button>
              </div>
            </Modal.Footer>
          </form>
      </Modal>
    </div>
  }
}

const mapState = state => ({

});

const mapDispatch = dispatch => ({
    
});

export default (connect(mapState, mapDispatch)(
  reduxForm({
    form: 'SuspendManualModal',
    destroyOnUnmount: true,
    enableReinitialize: true,
    validate
  })(withRouter(SuspendManualModal))));
